import Cookies from 'universal-cookie'
import { StateStorage } from 'zustand/middleware'

const defaultTTL = 1000 * 60 * 60 * 24 // 1 day
/**
 *
 * @param ttl number of milliseconds
 * @returns StateStorage object with get, set, and remove
 */
export function createCookieStorageWithTTL(ttl = defaultTTL): StateStorage {
  const cookies = new Cookies()
  return {
    getItem: (name: string) => {
      if (typeof window === 'undefined') return null
      return cookies.get<string>(name) ?? null
    },
    setItem: (name: string, value: string) => {
      if (typeof window === 'undefined') return

      cookies.set(name, value, {
        expires: new Date(Date.now() + ttl),
      })
    },
    removeItem: (name: string) => {
      if (typeof window === 'undefined') return
      cookies.remove(name)
    },
  }
}
